import { Value as BaseValue, Label, LineItem } from "../../common";
import { marginRight } from "../../../../../styles";
import Pill from "../../../../Pill/Pill";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
export type TotalLineProps = {
  getCurrencyDisplay: (n: number) => string;
  total: number;
};
const Value = styled(BaseValue)`
  ${marginRight.zero}
`;
export function TotalLine({
  getCurrencyDisplay,
  total
}: TotalLineProps) {
  const {
    t
  } = useTranslation();
  return <LineItem data-sentry-element="LineItem" data-sentry-component="TotalLine" data-sentry-source-file="TotalLine.tsx">
      <Label data-sentry-element="Label" data-sentry-source-file="TotalLine.tsx">{t("total")}</Label>
      <Value data-sentry-element="Value" data-sentry-source-file="TotalLine.tsx">
        <Pill small data-sentry-element="Pill" data-sentry-source-file="TotalLine.tsx">{getCurrencyDisplay(total)}</Pill>
      </Value>
    </LineItem>;
}
export default TotalLine;